<script>
    import ProgressBar from '../components/ProgressBar.svelte';
    import { navigate } from 'svelte-routing';
    import { store } from '../Store.svelte';

    let clickHandler = () => {
        navigate(
            $store.requestedServices.isSky ? '/comparador/sky' : '/comparador',
            { replace: false }
        );
        location.reload();
    };
</script>

<header>
    <div class="pure-g">
        <div class="pure-u-1">
            <div class="header-contents">
                <div
                    on:click={clickHandler}
                    on:keydown={clickHandler}
                    class="header-logo"
                >
                    {#if $store.requestedServices.isSky}
                        <img
                            src="/assets/img/logos/sky-logo.svg"
                            alt="Sky logo"
                        />
                    {:else}
                        <img
                            src="/assets/img/logos/izzi-logo.svg"
                            alt="izzi logo"
                        />
                    {/if}
                </div>
                <div class="header-spacer"></div>
                <ProgressBar
                    progress={$store.settings.location.progress}
                    step={$store.settings.location.step}
                />
            </div>
        </div>
    </div>
</header>
